import Vue from 'vue';
import axios from 'axios';
import { Message } from 'element-ui';
import {noToken} from "./noToken"
// import { getToken } from "@/utils/auth";
import { getSession, removeSession} from '@/utils/methods';
import { cancelApi, myLoading } from '@/utils/myApi';
import { Promise } from 'core-js';
import language from '@/utils/checkLang';
let Loading = new myLoading('#app');
let CancelApi = new cancelApi();
Vue.prototype.CancelApi = CancelApi;
let baseURL = process.env.VUE_APP_BASE_API;
let serverpage = "/serverpage"
if (baseURL === '/pro' || (baseURL === '/preview' || !baseURL)) {
    baseURL = window.baseURL;
    serverpage = window.serverpage //公司演示
}
Vue.prototype.$baseUrl = baseURL
Vue.prototype.$serverpage = serverpage
const server = axios.create({
	baseURL: baseURL,
	timeout: 50000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  }
});

server.interceptors.request.use(
	config => {
		CancelApi.remove(config);
		CancelApi.add(config);
		// config.headers.Authorization = getToken() || "";
		config.headers['H-Customer-Menu'] = window._menu_id
		config.headers["Accept-Language"] = getSession('LanguageName') || 'zh-cn';
		config.headers.Authorization = getSession('vue_admin_template_token') || '';
		if (config.url === '/route/route') {
			Loading.start('正在初始化请稍等...');
		} else {
		
			// Loading.start("喝杯茶稍等一下啵");
			// Loading.start("数据加载中...");
		}
		if(noToken.indexOf(config.url)>-1){
				config.headers.Authorization=''
		}
		return config;
	},
	err => {
		console.error('error://', err);
		return Promise.reject(err);
	}
);

server.interceptors.response.use(
	response => {
		Vue.prototype.$jsons = response;
		if(response.config.url.indexOf('/sys/user/') != -1) {
		}else {
			CancelApi.remove(response);
		}
		Loading.end();
		if (
			(typeof response.data == 'string' || response.data instanceof Blob) && response.status == 200
		) {
			return response;
		}
		// 判断鉴权
		if(response.config.url == '/activiti/hasRevocation') {
			return response.data
		}
		const res = response.data;
		if (!res.status) {
			if(res.code == 500 && res.message == '该列表配置已被删除') {
				Message.error(language.addTips.noUse);
				return;
			}
			Message.error({
				message:(language.$message[res.message] || res.message  ) || 'Error',
				type: 'error',
				duration: 3000,
			});
			if (res.code == 400) {
				return false;
			}
			if (res.code == 401) {
				// token过期
				removeSession("vue_admin_template_token");
				removeSession("tags");
				removeSession("hxemail_token");
				removeSession("uid");
				removeSession("users");
				removeSession("headerCollapse");
				removeSession("listTreeCollapse");
				removeSession("emailLogin");
				window.location = window.location.origin;
			}
			return Promise.reject(new Error(res.message || 'Error'));
		}

		// res.message &&
		//   MessageMessage.success({
		//     message: res.message,
		//     duration: 1000,
		//   });
		return res.data;
	},
	err => {
		Loading.end();
		if (!axios.isCancel(err)) {
			// console.error('error://', err);
			// Message.error({
			// 	message: err.message,
			// 	duration: 4000,
			// });
		}
		let promise = new Promise(() => {
			setTimeout(() => {
				// promise.cancel();
			});
		});
		return promise;
	}
);

export default server;
